var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloodlightCam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.333h-2.667V20h2.667v-6.667z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667.667a4.667 4.667 0 00-4.574 3.746 6.493 6.493 0 00-4.186 0A4.667 4.667 0 105.333 10 6.666 6.666 0 008 16v5.333l.667 1.334a3.413 3.413 0 006.667 0L16 21.333V16a6.667 6.667 0 002.667-6.027 4.666 4.666 0 100-9.333v.027zM2 5.333a3.333 3.333 0 116.667 0 3.333 3.333 0 01-6.667 0zM12 24a1.986 1.986 0 01-2-1.333h4A1.986 1.986 0 0112 24zm2.667-2.667H9.333V12h5.334v9.333zm2.667-10.6A5.334 5.334 0 0116 14.2v-3.173a.36.36 0 00-.36-.36H8.36a.36.36 0 00-.36.36V14.2a5.333 5.333 0 01-1.333-3.467c.002-.331.037-.662.106-.986A4.627 4.627 0 009.947 5.84a5.013 5.013 0 014.107 0 4.626 4.626 0 003.173 3.907c.069.324.105.655.107.986zm1.333-2.066a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667z",
    fill: "#1998D5"
  })));
}
export default SvgFloodlightCam;